// The in-game rules: the same dictionary copy @bn-games/vite-seo renders into
// the static /chess/rules/ pages, so the two can never drift apart.
import type { MenuScreen } from '../types.js';
import { createScreenShell, createMenuHeader, el } from '@bn-games/ui-shell';
import { t } from '../../i18n/I18n.js';
import { en } from '../../i18n/locales/en.js';
import { backRow } from './backButton.js';

type RuleKey = keyof typeof en.rules.fide.items;
const RULE_KEYS = Object.keys(en.rules.fide.items) as RuleKey[];

export function createRulesScreen(): MenuScreen {
  let frame: HTMLElement | null = null;

  return {
    mount(root, ctx) {
      const shell = createScreenShell();
      frame = shell.frame;
      const list = el('div', {
        class: 'rules',
        attrs: { role: 'region', 'aria-label': t('rules.fide.title'), tabindex: '0' },
      }, RULE_KEYS.map((key) => el('article', { class: 'rule-card' }, [
        el('h3', { class: 'rule-card__heading', text: t(`rules.fide.items.${key}.title`) }),
        el('p', { class: 'rule-card__body', text: t(`rules.fide.items.${key}.body`) }),
      ])));
      shell.body.append(createMenuHeader({ title: t('rules.screenTitle') }), list, backRow(ctx));
      root.appendChild(frame);
    },
    unmount() {
      frame?.remove();
      frame = null;
    },
  };
}
